import styled from "styled-components";
import {Section, SectionSubTitle, SectionTitle, Container as SecContainer, Grid, BtnFlex} from '../ReUsableStyles';


export const QualificationSection = styled.section`
    ${Section};
`;
export const Title = styled.h2`
    ${SectionTitle};
`;
export const Subtitle = styled.span`
    ${SectionSubTitle};
`;
export const Container = styled.div`
    ${SecContainer};
`;
export const Tabs = styled.div`
    display: flex;
    justify-content: space-evenly;
    margin-bottom: var(--mb-2);
`;
export const ButtonWrapper = styled.div`
    ${BtnFlex};
    font-size:var(--h3-font-size);
    font-weight: var(--font-medium);
    cursor: pointer;
    color: ${(props)=>props.open && "var(--first-color)"};
    &:hover{
        color:var(--first-color);
    }
    .qualification__icon{
        margin-right:var(--mb-0-25);
    }
`;

export const QualificationWrapper = styled.div`
    
`;

export const Content = styled.div`
    display: ${(props)=> props.open? "block":"none"}
`;

export const Data = styled.div`
    display:grid;
    grid-template-columns: 1fr max-content 1fr;
    column-gap: 1.5rem;
`;

export const QualificationTitle = styled.h3`
    font-size: var(--normal-font-size);
    font-weight: var(--font-medium);
`;

export const QualificationSubtitle = styled.span`
    display: inline-block;
    font-size: var(--small-font-size);
    margin-bottom: var(--text-color-light);
    
`;

export const Calendar = styled.div`
    ${BtnFlex};
    font-size: var(--smaller-font-size);
    color: var(--text-color-light);
`;

export const Rounder = styled.span`
    display: inline-block;
    width:13px;
    height: 13px;
    background-color: var(--first-color);
    border-radius: 50%;
`;
export const Line = styled.span`
    display: block;
    width: 1px;
    height: 100%;
    background-color: var(--first-color);
    transform: translate(6px, -7px);
`;